import { prepareAndNavigateForAuthentication } from '@utils/common';

const useNavigateToLogin = () => {
  return { navigateToLogin: prepareAndNavigateForAuthentication };
};

export default useNavigateToLogin;
